import Svg, { Path } from 'react-native-svg'

export const QrTabIcon = ({ height = 24, width = 24, color = '#000' }) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none">
      <Path
        fill={color}
        fillOpacity={1}
        d="M7 15H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2Zm5-6c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1Zm7-6h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2ZM5 9h2c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2Zm14 2h-2c-1.1 0-2 .9-2 2v2c0 1.1.9 2 2 2h2c1.1 0 2-.9 2-2v-2c0-1.1-.9-2-2-2Zm1 8h-7v-6c0-1.1-.9-2-2-2H4c-.55 0-1 .45-1 1s.45 1 1 1h7v6c0 1.1.9 2 2 2h7c.55 0 1-.45 1-1s-.45-1-1-1Z"
      />
    </Svg>
  )
}
